var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h4v10h-4V59zm-21.26-.48l2.83 2.83 7.07-7.07-2.83-2.83-7.07 7.07zM17 36H7v4h10v-4zm42 0v4h10v-4H59zm-7.64 18.28l7.07 7.07 2.83-2.83-7.07-7.07-2.83 2.83zM54.25 38A15.92 15.92 0 1130 24.47V17a8 8 0 0116 0v7.06A15.92 15.92 0 0154.25 38zm-4 0A11.9 11.9 0 0042 26.68V18h-8v8.92a11.94 11.94 0 00-7.49 12.59A11.92 11.92 0 0050.25 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Light_on.815517c8.svg";
export { SvgA3LightOn as ReactComponent };